import React, { useState } from "react";
import { Row, Col, Card, CardBody, Button, Container } from "reactstrap";
import { Helmet } from 'react-helmet-async';
import logolight from "../../assets/images/logo-dark.png";

//SweetAlert
// import SweetAlert from "react-bootstrap-sweetalert"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

const UiSweetAlert = () => {
  const [dynamic_title] = useState("Dynamic Title");
  const current_ip = "219.91.239.22";

  const MySwal = withReactContent(Swal);

  const showSuccessSwal = () => {
    MySwal.fire({
      title: dynamic_title,
      icon: "success",
    });
  };
  const showBasicSwal = () => {
    MySwal.fire({
      title: "Any fool can use a computer",
    });
  };
  const showTitleSwal = () => {
    MySwal.fire({
      title: "The Internet?",
      icon: "question",
      text: "That thing is still around?",
    });
  };
  const showConfirmSwal = () => {
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "green",
      cancelButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: dynamic_title,
          icon: "success",
        });
      }
    });
  };
  const showConfirmBothSwal = () => {
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "green",
      cancelButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: dynamic_title,
          icon: "success",
          text: "Your file has been deleted.",
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        MySwal.fire({
          title: dynamic_title,
          icon: "error",
          text: "Your imaginary file is safe :)",
        });
      }
    });
  };
  const showImgHeaderSwal = () => {
    MySwal.fire({
      title: "Sweet!",
      imageUrl: logolight,
    });
  };
  const showTimerSwal = () => {
    MySwal.fire({
      title: "Auto Close Alert!",
      showConfirmButton: false,
      text: "I Will close in 2 Seconds",
      timer: 2000,
    });
  };
  const showImgHtmlSwal = () => {
    MySwal.fire({
      title: (
        <span>
          HTML <u>example</u>!
        </span>
      ),
      icon: "warning",
      html: (
        <>
          You can use <b>bold</b> text, links and other HTML tags
        </>
      ),
    });
  };
  const showCustomDivSwal = () => {
    MySwal.fire({
      title: "Custom width, padding, background.",
      background: "#ebebeb",
      padding: "3em",
    });
  };
  const showCustomDiv1Swal = () => {
    MySwal.fire({
      title: "Your Work Has been Saved.",
      timer: 2000,
      showCancelButton: false,
      showConfirmButton: false,
      icon: "success",
      position: "top-right",
    });
  };
  const showAjaxSwal = () => {
    MySwal.fire({
      title: "Submit email to run ajax request",
      html: (
        <input
          type="email"
          className="form-control"
          placeholder="Enter Email"
        />
      ),
    }).then((result) => {
      MySwal.fire({
        title: dynamic_title,
        icon: "success",
      });
    });
  };
  const showStep1Swal = () => {
    MySwal.fire({
      title: "Question 1",
      text: "Chaining swal2 modals is easy",
    }).then(showStep2Swal);
  };
  const showStep2Swal = () => {
    MySwal.fire({
      title: "Question 2",
      text: "Chaining swal2 modals is easy",
    }).then(showStep3Swal);
  };
  const showStep3Swal = () => {
    MySwal.fire({
      title: "Question 3",
      text: "Chaining swal2 modals is easy",
    }).then(showFinalStepSwal);
  };
  const showFinalStepSwal = () => {
    MySwal.fire({
      title: "All done!",
    });
  };
  const showQueueStepSwal = () => {
    MySwal.fire({
      title: "Your public IP",
      confirmBtnText: "Show my public IP",
      text: "Your public IP will be received via AJAX request",
    }).then(showFinalQueueSwal);
  };
  const showFinalQueueSwal = () => {
    MySwal.fire({
      title: "",
      text: current_ip,
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Helmet>
          <title>Sweet Alert | Samply - React Admin & Dashboard Template</title>
        </Helmet>
        <Container fluid={true}>
          <Breadcrumbs title="Advanced Kit" breadcrumbItem="Sweet Alert" />

          <Card>
            <CardBody>
              <h4 className="card-title">Examples</h4>
              <p className="card-title-desc">
                A beautiful, responsive, customizable and accessible (WAI-ARIA)
                replacement for JavaScript's popup boxes. Zero dependencies.
              </p>
              <Row className="text-center">
                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <div className="p-3">
                    <p>A basic message</p>

                    <Button
                      color="primary"
                      onClick={showBasicSwal}
                      id="sa-basic"
                    >
                      Click me
                    </Button>
                  </div>
                </Col>

                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <div className="p-3">
                    <p>A title with a text under</p>
                    <Button
                      color="primary"
                      onClick={showTitleSwal}
                      id="sa-title"
                    >
                      Click me
                    </Button>
                  </div>
                </Col>

                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <div className="p-3">
                    <p>A success message!</p>
                    <Button
                      color="primary"
                      onClick={showSuccessSwal}
                      id="sa-success"
                    >
                      Click me
                    </Button>
                  </div>
                </Col>
                <Col xl={3} lg={4} sm={6} className="mb-2">
                  <div className="p-3">
                    <p>
                      A warning message, with a function attached to the
                      "Confirm"-button...
                    </p>
                    <Button
                      color="primary"
                      onClick={showConfirmSwal}
                      id="sa-success"
                    >
                      Click me
                    </Button>
                  </div>
                </Col>

                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <div className="p-3">
                    <p>
                      By passing a parameter, you can execute something else for
                      "Cancel".
                    </p>
                    <Button
                      color="primary"
                      onClick={showConfirmBothSwal}
                      id="sa-params"
                    >
                      Click me
                    </Button>
                  </div>
                </Col>
                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <div className="p-3">
                    <p>A message with custom Image Header</p>
                    <Button
                      color="primary"
                      onClick={showImgHeaderSwal}
                      id="sa-image"
                    >
                      Click me
                    </Button>
                  </div>
                </Col>
                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <div className="p-3">
                    <p>A message with auto close timer</p>
                    <Button color="primary" onClick={showTimerSwal}>
                      Click me
                    </Button>
                  </div>
                </Col>
                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <div className="p-3">
                    <p>Custom HTML description and buttons</p>
                    <Button
                      color="primary"
                      className="mb-md-4"
                      onClick={showImgHtmlSwal}
                      id="custom-html-alert"
                    >
                      Click me
                    </Button>
                  </div>
                </Col>
                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <div className="p-3">
                    <p>A custom positioned dialog</p>
                    <Button
                      type="button"
                      color="primary"
                      onClick={showCustomDiv1Swal}
                      className=" "
                      id="sa-position"
                    >
                      Click me
                    </Button>
                  </div>
                </Col>
                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <div className="p-3">
                    <p>A message with custom width, padding and background</p>
                    <Button
                      color="primary"
                      onClick={showCustomDivSwal}
                      id="custom-padding-width-alert"
                    >
                      Click me
                    </Button>
                  </div>
                </Col>

                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <p className="mt-3">Ajax request example</p>
                  <Button
                    color="primary"
                    onClick={showAjaxSwal}
                    id="ajax-alert"
                  >
                    Click me
                  </Button>
                </Col>
                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <div className="p-3">
                    <p>Chaining modals (queue) example</p>
                    <Button
                      color="primary"
                      onClick={showStep1Swal}
                      id="chaining-alert"
                    >
                      Click me
                    </Button>
                  </div>
                </Col>

                <Col xl="3" lg="4" sm="6" className="mb-2">
                  <div className="p-3">
                    <p>Dynamic queue example</p>
                    <Button
                      color="primary"
                      onClick={showQueueStepSwal}
                      id="dynamic-alert"
                    >
                      Click me
                    </Button>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UiSweetAlert;
